import Town from "../town";
import TownPlay from "../town-play";
import { TileSet, GamePage } from "../interfaces";
import { state } from "../index";

import { loadTexture } from "../helpers/webgl-helpers";
import { lockCameraPosition$ } from "../town-observables";
import Ttam from "../sprites/ttam";

import sharesburgTileMap from "../../assets/maps/test-map.json";

const sharesburgTileSet = sharesburgTileMap.tilesets.find(
  (tileSet: TileSet) => tileSet.name === "terrain"
);
const sharesburgNormalTileSet = sharesburgTileMap.tilesets.find(
  (tileSet: TileSet) => tileSet.name === "terrain-n"
);

export default class Sharesburg extends Town implements GamePage {
  name = "sharesburg";

  async load(params) {
    await super.load(params);

    this.resize();

    const { gameGl } = this;

    const tileSetImageUrl = await import(`../../assets/maps/${sharesburgTileSet.image}`).then(
      i => i.default
    );

    const normalTextureUrl = await import(
      `../../assets/maps/${sharesburgNormalTileSet.image}`
    ).then(i => i.default);

    this.tileMap = sharesburgTileMap;
    this.tileSet = sharesburgTileSet;
    this.texture = await loadTexture(gameGl, tileSetImageUrl);
    this.normalTexture = await loadTexture(gameGl, normalTextureUrl);
    this.tileLayer = this.tileMap.layers.find(layer => layer.name === "main");

    this.configureStateWithCurrentMap();
    this.configureTileInAnimation();

    const ttam: Ttam = new Ttam(gameGl, "main");
    state.currentPlayer = ttam;
    await state.currentPlayer.load();
    this.townPlay = new TownPlay(this.townTime$);
    const cameraLoop$ = lockCameraPosition$(state.viz.camera, state.currentPlayer);

    this.townPlay.addCharacter("camera", state.viz.camera, cameraLoop$);
    this.spriteRenderer.add(ttam);
    state.currentPlayer.updatePos(5, -2);

    this.dayLevel = 0.9;
    this.lightPositions[0] = 5;
    this.lightPositions[1] = -5;
    this.lightPositions[2] = 1.0;
    this.lightColors[0] = 1.0;
    this.lightColors[1] = 0.5;
    this.lightColors[2] = 0.5;
    this.lightDropoffs[0] = 1.5;
    this.spriteRenderer.sort();

    // await new Promise(resolve => {
    //   setTimeout(() => {
    //     resolve();
    //   }, 25000);
    // });

    this.loaded = true;
  }
}
